import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';

import { getPlatformDetailsSelector } from '../../../../platform/platformSelector';
import { isPlatformInstalledApp } from '../../../../platform/utils/platformDetailsUtils';

import { createVersionString } from '../../../../utils/versionUtils';

import PopupPanelAsideSection from '../../../../components/popupPanel/types/asideSection/PopupPanelAsideSection';
import ElectronVisible from '../../../../components/electron/ElectronVisible';
import ElectronUpdateStatus from './electronApp/ElectronUpdateStatus';
import PwaOnly from '../../../../pwaApp/PwaOnly';
import PwaAppVersionStatus from './pwa/PwaAppVersionStatus';

import './VersionBanner.scss';

const mapStateToProps = createStructuredSelector({
    platformDetails: getPlatformDetailsSelector,
});

const VersionBanner = (props) => {
    const { platformDetails } = props;

    if (!isPlatformInstalledApp(platformDetails)) return null;

    return (
        <PopupPanelAsideSection className="VersionBanner">
            <div className="VersionString">{createVersionString(platformDetails)}</div>

            <ElectronVisible>
                <ElectronUpdateStatus {...props} />
            </ElectronVisible>

            <PwaOnly>
                <PwaAppVersionStatus />
            </PwaOnly>
        </PopupPanelAsideSection>
    );
};

VersionBanner.propTypes = {
    platformDetails: PropTypes.object,
};

export default connect(mapStateToProps)(VersionBanner);
